module.exports = __webpack_public_path__ + "img/live-state.06e1590e.png";